module.exports = __webpack_public_path__ + "static/img/data_2.5c6db36.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/data_2.jpg
// module id = EJY6
// module chunks = 1